(function () {
  "use strict";

  const PURCHASE_TYPES = ["subscription", "one-time"];

  function normalizeBundleSet(targetSet = "") {
    const setMatch = String(targetSet || "").match(/\d+/);
    return setMatch ? `set-${setMatch[0]}` : String(targetSet || "");
  }

  function getSetNumber(targetSet = "") {
    return normalizeBundleSet(targetSet).match(/\d+/)?.[0] || "";
  }

  function getSetValue(el, base, setNumber) {
    if (!el || !setNumber) return "";

    const camelKey = `${base}Set${setNumber}`;

    return (
      el.dataset?.[camelKey] ||
      el.getAttribute(`data-${base}-set${setNumber}`) ||
      el.getAttribute(`data-${base}-set-${setNumber}`) ||
      ""
    );
  }

  function getSharedBundleSelector() {
    return (
      document.querySelector("[data-shared-bundle-selector]") ||
      document.querySelector(".bundle-selector")
    );
  }

  function getActivePurchaseType() {
    return (
      document.querySelector(".purchase-type.active")?.dataset.type ||
      "subscription"
    );
  }

  function getActiveBundleSet() {
    const activeOption = getSharedBundleSelector()?.querySelector(
      ".bundle-option.active[data-target]",
    );

    if (activeOption?.dataset.target) {
      return normalizeBundleSet(activeOption.dataset.target);
    }

    const activeGroup = document.querySelector(
      ".bundle-group.active[data-bundle-set]:not(.hidden), .bundle-group[data-bundle-set]:not(.hidden)",
    );

    return normalizeBundleSet(activeGroup?.dataset.bundleSet || "set-2");
  }

  function parseMoney(value) {
    return parseFloat(String(value || "").replace(/[^0-9.]/g, ""));
  }

  function getDiscountPercent(price, compare) {
    const cleanPrice = parseMoney(price);
    const cleanCompare = parseMoney(compare);

    if (
      !Number.isFinite(cleanPrice) ||
      !Number.isFinite(cleanCompare) ||
      cleanCompare <= cleanPrice
    ) {
      return 0;
    }

    return Math.round(((cleanCompare - cleanPrice) / cleanCompare) * 100);
  }

  function getPricingSource(purchaseType, setNumber) {
    const typedSources = Array.from(
      document.querySelectorAll(`[data-purchase-type="${purchaseType}"]`),
    );

    return typedSources.find((el) => {
      return (
        (el.hasAttribute("data-bundle-price") ||
          el.hasAttribute("data-pricing-header") ||
          el.hasAttribute("data-bundle-unit")) &&
        getSetValue(el, "price", setNumber)
      );
    });
  }

  function getPricing(purchaseType, targetSet) {
    const activeSet = normalizeBundleSet(targetSet || getActiveBundleSet());
    const setNumber = getSetNumber(activeSet);
    const source = getPricingSource(purchaseType, setNumber);

    if (!source || !setNumber) return null;

    const price = getSetValue(source, "price", setNumber);
    const compare = getSetValue(source, "compare", setNumber);
    const unitSource = document.querySelector(
      `[data-bundle-unit][data-purchase-type="${purchaseType}"]`,
    );
    const unit =
      getSetValue(source, "unit", setNumber) ||
      getSetValue(unitSource, "unit", setNumber) ||
      "";

    if (!price && !compare) return null;

    return {
      purchaseType,
      set: activeSet,
      setNumber,
      price,
      compare,
      unit,
      percent: getDiscountPercent(price, compare),
    };
  }

  function setHidden(el, hidden) {
    if (!el) return;
    el.hidden = Boolean(hidden);
    el.style.display = hidden ? "none" : "";
  }

  function updatePriceTargets(pricing) {
    document
      .querySelectorAll(
        `[data-bundle-price][data-purchase-type="${pricing.purchaseType}"]`,
      )
      .forEach((el) => {
        el.innerHTML = pricing.compare
          ? `${pricing.price} <s>${pricing.compare}</s>`
          : pricing.price;
        el.dataset.activePurchaseType = pricing.purchaseType;
        el.dataset.activeBundleSet = pricing.set;
      });
  }

  function updateUnitTargets(pricing) {
    document
      .querySelectorAll(
        `[data-bundle-unit][data-purchase-type="${pricing.purchaseType}"], .ph-unit[data-purchase-type="${pricing.purchaseType}"]`,
      )
      .forEach((el) => {
        const unit = pricing.unit || getSetValue(el, "unit", pricing.setNumber);
        if (!unit) return;
        el.textContent = unit;
        el.dataset.activePurchaseType = pricing.purchaseType;
        el.dataset.activeBundleSet = pricing.set;
      });
  }

  function updateDiscountTargets(pricing) {
    document
      .querySelectorAll(
        `[data-bundle-discount][data-purchase-type="${pricing.purchaseType}"]`,
      )
      .forEach((el) => {
        el.textContent = pricing.percent ? `-${pricing.percent}%` : "";
        setHidden(el, !pricing.percent);
        el.dataset.activePurchaseType = pricing.purchaseType;
        el.dataset.activeBundleSet = pricing.set;
      });
  }

  function updatePricingHeaders(pricing) {
    document
      .querySelectorAll(
        `[data-pricing-header][data-purchase-type="${pricing.purchaseType}"]`,
      )
      .forEach((header) => {
        const price =
          getSetValue(header, "price", pricing.setNumber) || pricing.price;
        const compare =
          getSetValue(header, "compare", pricing.setNumber) || pricing.compare;
        const unit =
          getSetValue(header, "unit", pricing.setNumber) || pricing.unit;
        const percent = getDiscountPercent(price, compare);

        const compareEl = header.querySelector(".pricing-compare");
        const currentEls = header.querySelectorAll(
          ".pricing-current, .ph-current",
        );
        const discountEls = header.querySelectorAll(
          ".pricing-discount, .ph-discount",
        );
        const unitEls = header.querySelectorAll(".pricing-per-unit, .ph-unit");

        if (compareEl) {
          compareEl.textContent = compare || "";
          setHidden(compareEl, !compare);
        }

        currentEls.forEach((el) => {
          el.textContent = price || "";
        });

        discountEls.forEach((el) => {
          el.textContent = percent ? `-${percent}%` : "";
          setHidden(el, !percent);
        });

        unitEls.forEach((el) => {
          if (unit) el.textContent = unit;
        });
      });
  }

  function updateSelectorLabels(activePurchaseType) {
    const selector = getSharedBundleSelector();
    if (!selector) return;

    selector.querySelectorAll(".bundle-option").forEach((btn) => {
      const unit =
        activePurchaseType === "one-time"
          ? btn.dataset.oneUnit
          : btn.dataset.subUnit;
      const content =
        activePurchaseType === "one-time"
          ? btn.dataset.oneContent
          : btn.dataset.subContent;
      const small = btn.querySelector("[data-bundle-option-unit], small");

      if (unit && small) small.textContent = unit;
      if (content) btn.dataset.content = content;
    });
  }

  function syncBundleGroups(targetSet) {
    const activeSet = normalizeBundleSet(targetSet || getActiveBundleSet());
    if (!activeSet) return;

    document
      .querySelectorAll(".one-time-bundle, .subscription-bundle")
      .forEach((section) => {
        section
          .querySelectorAll(".bundle-group[data-bundle-set]")
          .forEach((group) => {
            const isActiveGroup =
              normalizeBundleSet(group.dataset.bundleSet) === activeSet;
            group.classList.toggle("active", isActiveGroup);
            group.classList.toggle("hidden", !isActiveGroup);
          });
      });
  }

  function syncAllBundlePricing(targetSet = getActiveBundleSet()) {
    const activeSet = normalizeBundleSet(targetSet || getActiveBundleSet());
    const activePurchaseType = getActivePurchaseType();

    updateSelectorLabels(activePurchaseType);
    syncBundleGroups(activeSet);

    const updates = PURCHASE_TYPES.map((purchaseType) => {
      const pricing = getPricing(purchaseType, activeSet);
      if (!pricing) return null;

      updatePriceTargets(pricing);
      updateUnitTargets(pricing);
      updateDiscountTargets(pricing);
      updatePricingHeaders(pricing);

      return pricing;
    }).filter(Boolean);

    document.dispatchEvent(
      new CustomEvent("bundle:all-pricing-synced", {
        detail: {
          set: activeSet,
          activePurchaseType,
          updates,
        },
      }),
    );

    return updates;
  }

  function scheduleSync(targetSet = null) {
    const setToSync = targetSet || getActiveBundleSet();

    requestAnimationFrame(() => {
      syncAllBundlePricing(setToSync);

      // Run once more after older inline handlers that may update .ph-unit/.ph-discount globally.
      setTimeout(() => syncAllBundlePricing(setToSync), 0);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    scheduleSync();
  });

  document.addEventListener("click", (event) => {
    const bundleOption = event.target.closest(".bundle-option[data-target]");
    if (bundleOption) {
      const targetSet = normalizeBundleSet(bundleOption.dataset.target);

      document
        .querySelectorAll(".bundle-selector .bundle-option")
        .forEach((option) => {
          option.classList.toggle(
            "active",
            normalizeBundleSet(option.dataset.target) === targetSet,
          );
        });

      scheduleSync(targetSet);
      return;
    }

    if (event.target.closest(".purchase-type[data-type]")) {
      scheduleSync();
    }
  });

  document.addEventListener("bundle:pricing-updated", (event) => {
    scheduleSync(event.detail?.set || getActiveBundleSet());
  });

  window.bundleBuilder_syncAllPricing = syncAllBundlePricing;
})();
